import React, { useState, useEffect } from 'react'
import { apiHandler } from '../../api/apihandler';
import { MADE_IT_COMMENTS } from "../../api/constants";
import SingleUserMadeItComment from './singleUserMadeItComment'


const MadeItCommentList = ({ madeItId, refreshCommentList, setRefreshCommentList, onCommentAdded }) => {
    const [commentList, setCommentList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    // Load on mount
    useEffect(() => {
        getCommentList()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [madeItId])

    // Reload whenever the counter increments (skip initial value of 0)
    useEffect(() => {
        if (refreshCommentList > 0) {
            getCommentList()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshCommentList])

    async function getCommentList() {
        setIsLoading(true)
        try {
            const res = await apiHandler(MADE_IT_COMMENTS, "POST", {
                page: 1,
                limit: 100,
                made_it_id: madeItId
            })
            if (res.data?.response?.status === 200) {
                setCommentList(res?.data?.data?.comments?.data ?? res?.data?.data?.data ?? [])
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="nmha-made-it-comment-area">
            {isLoading ? (
                <p className="nmha-empty-text">Loading comments…</p>
            ) : commentList?.length === 0 ? (
                <p className="nmha-empty-text">No comments yet. Be the first to comment!</p>
            ) : (
                commentList?.map((elm) => (
                    <div key={elm?.id}>
                        <SingleUserMadeItComment madeItId={madeItId} commentElm={elm} setRefreshCommentList={setRefreshCommentList} depth={0} onCommentAdded={onCommentAdded} />
                        {
                            elm?.replies?.map((innerElm) => (
                                <div key={innerElm?.id} style={{ marginLeft: "32px" }}>
                                    <SingleUserMadeItComment madeItId={madeItId} commentElm={innerElm} setRefreshCommentList={setRefreshCommentList} depth={1} onCommentAdded={onCommentAdded} />
                                    {
                                        innerElm?.replies?.map((innerElm2) => (
                                            <div key={innerElm2?.id} style={{ marginLeft: "32px" }}>
                                                <SingleUserMadeItComment madeItId={madeItId} commentElm={innerElm2} setRefreshCommentList={setRefreshCommentList} depth={2} onCommentAdded={onCommentAdded} />
                                            </div>
                                        ))
                                    }
                                </div>
                            ))
                        }
                    </div>
                ))
            )}
        </div>
    )
}

export default MadeItCommentList
